/**
 * Customized to add speedy as an option.
 */

import createCache from '@emotion/cache';

export const createEmotionCache = (options?: { speedy?: boolean }) =>
	createCache({
		key: 'css',
		prepend: true,
		speedy: options?.speedy,
	});
